import * as React from 'react'

export type Prop<K extends string, V> = {[prop in K]: V}

export function withContext
    <T, ContextPropName extends string, OtherProps>
    (contextPropName: ContextPropName, Consumer: React.Consumer<T>) {
  return (Component: React.ComponentType<OtherProps & Prop<ContextPropName, T>>): React.SFC<OtherProps> => {
    return (props: OtherProps) =>
      <Consumer>
        {(context: T) => {
          const contextProp: {[prop in ContextPropName]: T} = {[contextPropName]: context} as Prop<ContextPropName, T>
          return <Component {...props} {...contextProp} />
        }}
      </Consumer>
  }
}


// WEBPACK FOOTER //
// ./src/view/withContext.tsx